// import "babel-polyfill";

// require("es6-object-assign").polyfill();

import "./core/functions";
import "./core/patch";
import "./core/path";
import "./core/roles";

import Dispatcher from "./core/dispatcher-flyd";
import VDOM from "./vdom/vdom";
import Transform from "./core/transform";
import Request from "./core/request";
import UI from "./core/ui";

// pollute the global namespace
Object.assign (window, {
    Dispatcher: Dispatcher,
    VDOM: VDOM,
    Transform: Transform,
    Fetch: Request,

    // TODO: backwards compatability: remove
    REQ: Request,
    // Necessary?
    UI: UI
});